export const getMssTexts = (
  color?: 'red' | 'orange' | 'grey' | 'green',
  isAdult?: boolean,
  name?: string,
) => {
  const texts = {
    red: {
      mainText: `There are major imbalances, and we recommend taking action and resampling in the future.`,
    },
    orange: {
      mainText: `There may be imbalances in ${isAdult ? 'your' : `${name}'s`} microbiome, and we recommend taking action and resampling in the future.`,
    },
    grey: {
      mainText: `There may be minor imbalances in ${isAdult ? 'your' : `${name}'s`} microbiome. We recommend routine monitoring and resampling every 6 months.`,
    },
    green: {
      mainText: `There may be minor imbalances in ${isAdult ? 'your' : `${name}'s`} microbiome. We recommend routine monitoring and resampling every 6 months.`,
    },
  };

  return texts[color as keyof typeof texts] || texts.grey;
};
